(function () {
    'use strict'
  
    angular.module('MktzapApp.Factories')
      .factory('VersioningService', VersioningService)
  
    VersioningService.$inject = ['$resource']
  
    function VersioningService ($resource) {
      return $resource(apiUrl + '/versioning', {}, {
        all: { method: 'GET', params: {}, isArray: true },
        save: { method: 'POST', params: {}, isArray: false },
        delete: { method: 'DELETE', params: {}, isArray: false },
        update: { method: 'PATCH', params: {}, isArray: false },
        getLastVersion: { url: apiUrl + '/versioning/getLastVersion', method: 'GET', params: {}, isArray: false }
      })
    }
  })();
  